import { AiOutlineArrowRight } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

import SelectFilter from "@Components/Filters/SelectFilter";
import IconButton from "@Components/IconButton";
import Table from "@Components/Table";
import { Column } from "@Components/Table/types";
import useGetTickets from "@Hooks/useTickets";
import { LenderTicket, Priority, Status } from "@Types/tickets";
import { capitalize, formatDate } from "@Utils/functions";

import styles from "./Tickets.module.scss";

export const ticketStatusToColor = (status: Status) =>
  status === Status.Open
    ? "#ffbb6c"
    : status === Status.InProgress
    ? "#6B97F6"
    : status === Status.Sovled
    ? "#10b981"
    : "#EB8190";

export const priorityToColor = (priority: Priority) =>
  priority === Priority.Low
    ? "#a5aec1"
    : priority === Priority.Medium
    ? "#ffbb6c"
    : "#EB8190";

export const statusStyle = (background: string): React.CSSProperties => ({
  fontWeight: 700,
  fontSize: 18,
  background,

  borderRadius: "5px",
  justifyContent: "center",
  width: "90%",
  color: "#FFF",
  maxWidth: "250px",
  whiteSpace: "pre-wrap",
  textAlign: "center",
});
const Tickets = () => {
  const navigate = useNavigate();

  const columns: Column<LenderTicket>[] = [
    {
      id: "status",
      label: "Status",
      value: (ticket) => capitalize(ticket.data.info.status) ?? "",
      style: (ticket) =>
        statusStyle(ticketStatusToColor(ticket.data.info.status)),
      filters: [
        {
          placeholder: "Status",
          preview: SelectFilter,
          queryPath: ["data", "info", "status"],
          valuesForSelect: [
            Status.Closed,
            Status.Open,
            Status.InProgress,
            Status.Sovled,
          ].map((x) => ({
            label: x,
            value: x,
          })),
        },
      ],
    },
    {
      id: "subject",
      label: "Subject",
      value: (ticket) => ticket.data.info.subject ?? "",
    },

    {
      id: "dateAdded",
      label: "Date",
      value: (deal) => formatDate(deal.createdAt, "short"),
      sortPath: ["data", "createdAt"],
    },

    {
      id: "priority",
      label: "Priority",
      value: (ticket) => capitalize(ticket.data.info.priority) ?? "",
    },
    {
      id: "actions",
      label: "Details",
      value: (ticket) => (
        <IconButton
          id={`open-ticket-${ticket?._id}`}
          className={"blueCircle"}
          onClick={() => {
            navigate(`/tickets/${ticket._id}`);
          }}
        >
          <AiOutlineArrowRight size={18} />
        </IconButton>
      ),
    },
  ];

  return (
    <div className={styles.tableContainer}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
        }}
      >
        <h2 className={styles.title}>Tickets</h2>
      </div>
      <Table<LenderTicket>
        columns={columns}
        useGetFunction={useGetTickets}
        entityType="tickets"
      />
    </div>
  );
};

export default Tickets;
